import { render, staticRenderFns } from "./selectValMunicipio.vue?vue&type=template&id=173d9180&"
import script from "./selectValMunicipio.vue?vue&type=script&lang=js&"
export * from "./selectValMunicipio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports